var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Typography } from '@material-ui/core';
import CourseImage from '../../Image/components/CourseImage';
import DotList from '../../Structure/DotList';
import { ListItemContainer, ListItemInfoContainer, ListItemImageContainer, ListItemDescriptionDotListContainer } from '../ListItem.styles';
const CourseListItem = (_a) => {
    var { skillImages, image, title, subtitle, description, children } = _a, otherProps = __rest(_a, ["skillImages", "image", "title", "subtitle", "description", "children"]);
    return (React.createElement(ListItemContainer, Object.assign({ tabIndex: 0, role: "button", "aria-disabled": false }, otherProps),
        React.createElement(ListItemImageContainer, null,
            React.createElement(CourseImage.Small, { skillImages: skillImages, image: image, "aria-label": title })),
        React.createElement(ListItemInfoContainer, null,
            title ? React.createElement("h4", null, title) : null,
            subtitle ? React.createElement(Typography, { variant: "subtitle2" }, subtitle) : null,
            description ? (React.createElement(DotList, { styledComponentOverride: ListItemDescriptionDotListContainer }, description)) : null),
        children));
};
export default CourseListItem;
//# sourceMappingURL=index.js.map